<template>
    <div>
    </div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    created() {
        
    },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/customerService.vue